var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.amount > 0)?_c('div',{staticClass:"hidden-mobile"},[_c('div',{staticClass:"holidays-to-approve"},[_c('heading',{attrs:{"colour":"white","size":"medium","no-margin":""}},[_vm._v("Holidays To Approve")]),_vm._v(" "),_c('p',[_vm._v("There are holiday requests to approve for "+_vm._s(_vm.amount)+" Employee/s.")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }